import React from 'react';
import md from '../../../../../meta/cat/contragent';
import ListerFactory from '../../../../newLister';
// eslint-disable-next-line import/no-cycle
import { CatTableListerFactory } from '../../../../newLister/tableComponent';
import ListerSelector from '../_classifierLister/lister_selector';
import ClassifierRow from '../_classifierLister/classifierRow';
import CommandPanel from '../../../../newLister/tableComponent/commandpanel/cat_panel';

function CommandPanelWithoutFilter() {
  return (
    <CommandPanel
      noFilter
    />
  );
}

const StdLister = ListerFactory({
  backendURL: md.backendURL,
  viewType: 'lister',
})(CatTableListerFactory({
  RowComponent: ClassifierRow,
  CommandPanel: CommandPanelWithoutFilter,
}));

function Lister(props) {
  return (
    <ListerSelector {...props}>
      <StdLister />
    </ListerSelector>
  );
}

export default Lister;
